import { put, takeLatest } from "redux-saga/effects";
import { postCalculateCartApi } from "store/api/OrderApi";
import { CALCULLATE_CART_ACTION } from "../../actions/OrderPageAction/actionTypes";

import * as orderPageAction from "../../actions/OrderPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postCalculateCart(action) {
	yield put(globalAction.openLoadingPage());
	const { dataCalculateCart, onFail, onSuccess } = action.params;
	const res = yield postCalculateCartApi(dataCalculateCart);
	try {
		if (res?.code === 0) {
			yield put(orderPageAction.setCalculateCartAction(res?.data));
			onSuccess();
		} else {
			yield errorMessage(res?.message);
			yield put(orderPageAction.setCalculateCartAction({}));
			onFail();
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postCalculateCartSaga() {
	yield takeLatest(CALCULLATE_CART_ACTION, postCalculateCart);
}

export default postCalculateCartSaga;
